module.exports = "<a routerLink=\"/client/add\" class=\"btn btn-success btn-block\">\n  <i class=\"fa fa-plus\"></i> New\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sidebar/sidebar.component.html
// module id = ./src/app/components/sidebar/sidebar.component.html
// module chunks = main